import React, { useContext, useEffect, useState } from 'react';
import classes from "../routes/HomePage.module.css";
import { useNavigate } from 'react-router-dom';
import {  FaCopyright} from 'react-icons/fa6';
import { getImagesApi } from '../http/http';
import Loader from './Player/UI/Loader/Loader';
import Drawer from './Drawer';
import { LanguageContext } from '../routes/LanguageContext';

const CategoriesSection = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
    const { lang } = useContext(LanguageContext);
    
      const [loader, setLoader] = useState(true);
      const [drawer, setDrawer] = useState(false);
  
      const fetchImages = async () => {
          try {
              setLoader(true);
              const response = await getImagesApi();
              console.log(response, 'resposne....');
              setData(response?.data);
              setLoader(false);
  
          } catch (error) {
              setLoader(false);
  
              console.log(error, 'error----');
          }
      }
  
      useEffect(() => {
          fetchImages();
      }, []);

  return (
    <>
    <section className={classes.section_categories_page}>
      <div className={classes.container}>
        <h1 className={classes.section_categories_title}>
          Providing Good Qualities For Your Loving Kids
         {/* {lang=="eng" ?  "Providing Good Qualities For Your Loving Kids": "توفير الصفات الجيدة لأطفالك المحبين"} */}
        </h1>

        <div className={classes.section_categories_grid}>

          
          <div
            className={classes.category_item}
            onClick={() => navigate("/category/rhymes")}
          >
            <div className={classes.category_item_image}>
              <img
                src="/assets/images/rhymes.png"
                alt="rhyme"
                className={classes.category_image}
              />
            </div>
            <h1 className={classes.category_item_heading}>
              Kids Rhymes
              {/* {lang=="eng" ? "Kids Rhymes" :"أغاني الأطفال"} */}
              </h1>
            <p className={classes.category_item_description}>
            Kids rhymes are fun and educational songs that help young children learn language, rhythm, through catchy tunes and playful lyrics.
              {/* {lang=="eng" ? `Kids rhymes are fun and educational songs that help young children learn language, rhythm, through catchy tunes and playful lyrics.`: "أناشيد الأطفال هي أغاني ممتعة وتعليمية تساعد الأطفال الصغار على تعلم اللغة والإيقاع من خلال الألحان الجذابة والكلمات المرحة."} */}
            </p>
            <div className={classes.category_button_container}>
              <button
                type="button"
                className={classes.category_button}
                onClick={() => navigate("/category/rhymes")}
              >
                Watch Now
               {/* {lang=="eng" ? " Watch Now" : "شاهد الآن"} */}
              </button>
            </div>
          </div>

          
          <div
            className={classes.category_item}
            onClick={() => navigate("/category/learning")}
          >
            <div className={classes.category_item_image}>
              <img
                src="/assets/images/book.png"
                alt="learning"
                className={classes.category_image}
              />
            </div>
            <h1 className={classes.category_item_heading}>
              Kids Learning
              {/* {lang=="eng"?"Kids Learning":"تعلم الأطفال"} */}
              </h1>
            <p className={classes.category_item_description}>
              Kids learning is all about helping children grow through fun, play, and simple lessons that build language, thinking, and social skills.
              {/* {lang=="eng" ?"Kids learning is all about helping children grow through fun, play, and simple lessons that build language, thinking, and social skills." :"يعتمد تعلم الأطفال على مساعدتهم على النمو من خلال المرح واللعب والدروس البسيطة التي تبني اللغة والتفكير والمهارات الاجتماعية."} */}
            </p>
            <div className={classes.category_button_container}>
              <button
                type="button"
                className={classes.category_button}
                onClick={() => navigate("/category/learning")}
              >
                Watch Now
               {/* {lang=="eng" ? " Watch Now" : "شاهد الآن"} */}
              </button>
            </div>
          </div>

          
          <div
            className={classes.category_item}
            onClick={() => navigate("/category/stories")}
          >
            <div className={classes.category_item_image}>
              <img
                src="/assets/images/fairytale.png"
                alt="stories"
                className={classes.category_image}
              />
            </div>
            <h1 className={classes.category_item_heading}>
              Kids Stories
              {/* {lang=="eng"?"Kids Stories":"قصص الاطفال"} */}
              </h1>
            <p className={classes.category_item_description}>
              Kids stories spark imagination and teach values through fun characters and adventures, helping children learn and grow in a joyful way.
              {/* {lang=="eng" ? "Kids stories spark imagination and teach values through fun characters and adventures, helping children learn and grow in a joyful way.":"تعمل قصص الأطفال على تحفي الخيال وتعليم القيم من خلال الشخصيات والمغامرات الممتعة، مما يساعد الأطفال على التعلم والنمو بطريقة ممتعة."} */}
            </p>
            <div className={classes.category_button_container}>
              <button
                type="button"
                className={classes.category_button}
                onClick={() => navigate("/category/stories")}
              >Watch Now
               {/* {lang=="eng" ? " Watch Now" : "شاهد الآن"} */}
              </button>
            </div>
          </div>

        </div>
      </div>
    </section>
                <section className={classes.section_product_page}>
                <div className={classes.container_product}>
                    <h1 className={classes.section_product_page_heading}>
                      Special Care For Your Children
                      {/* {lang=="eng"?"Special Care For Your Children":"رعاية خاصة لأطفالك"} */}
                      </h1>

                    <div className={classes.section_product_page_grid}>
                        <div className={classes.section_product_page_grid_item}>
                            <p className={classes.section_product_page_grid_item_text1}>
                              Content Type
                                {/* {lang=="eng"?"Content Type":"نوع المحتوى"} */}
                            </p>
                            <p className={classes.section_product_page_grid_item_text2}>
                              3 Categories
                               {/* {lang=="eng" ? "3 Categories":"3 فئات"}  */}
                            </p>
                        </div>

                        <div className={classes.divider}>
                        </div>

                        <div className={classes.section_product_page_grid_item}>
                            <p className={classes.section_product_page_grid_item_text1}>
                              Browser Over
                             {/* {lang=="eng" ? "Browser Over" :"انتهى المتصفح"}    */}
                            </p>
                            <p className={classes.section_product_page_grid_item_text2}>
                              150+ Videos
                              {/* {lang=="eng" ?"150+ Videos" :"أكثر من 150 فيديو"}   */}
                            </p>
                        </div>
                    </div>

                    <h1 className={classes.section_product_page_heading2}>
                      Unlocking skills, One video at a time 🚀
                      {/* {lang=="eng" ? "Unlocking skills, One video at a time 🚀" :"فتح المهارات، فيديو واحد في كل مرة 🚀"}   */}
                    </h1>

                    <p className={classes.section_product_page_paragraph}>
                      Unlock joyful learning with KidsLab: Videos that spark brilliance. Explore, Watch, Learn!
                    {/* {lang=="eng" ?  "Unlock joyful learning with KidsLab: Videos that spark brilliance. Explore, Watch, Learn! ":"أطلق العنان لمتعة التعلم مع KidsLab: فيديوهات تُلهم الإبداع. استكشف، شاهد، تعلّم!" } */}
                    </p>
                </div>

                <img src="/assets/images/Book Illustration.png" alt="Book" className={classes.image_book_illustration} />
                <img src="/assets/images/World Illustration.png" alt="World" className={classes.image_world_illustration} />

                {loader ? <Loader on={loader} /> : (
                    <>
                        <div className={classes.section_carousel_marquee}>
                            <div className={classes.section_carousel_sub_container}>
                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}

                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </>
                )}


            </section>

            <section className={classes.footer}>
                <div className={classes.container}>
                    <div className={classes.footer_container}>
                        <div className={classes.footer_logo_container}>
                            <img src="/assets/images/logo.png" alt="logo" className={classes.footer_logo} />
                        </div>

                        <div className={classes.copyright_container}>
                            <FaCopyright className={classes.copyright_icon} />
                            <p className={classes.copyright_text}>
                                Rainboo Softmate Pvt Ltd
                            </p>
                        </div>
                    </div>


                </div>
            </section> 
            
     <Drawer setDrawer={setDrawer} drawer={drawer} />

    </>
  );
};

export default CategoriesSection;
